import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Box, Typography } from "@mui/material";
import ChatbotResponse from "./ChatbotResponse";
import ResponseOptionButton from "./responseOptionButton";
import { ReactComponent as Avatar } from "../Assets/blazebot-avatar.svg";

function LinkRenderer(props) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  );
}

const borderRadius = "1em";
// for spacing between messages
const topMargin = "10px";

function formatMessageTime(value) {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
}

const ChatMessage = ({ message, index, onFeedbackSubmit, onOptionClick, isLastMessage }) => {
  const themeMode = window.__ASKBLAZE_THEME_MODE__ === "dark" ? "dark" : "light";
  const messageTime = formatMessageTime(message.SentAt || message.Timestamp || message.CreatedAt);

  if (message.Role === "user") {
    return (
      <Box
        key={index}
        sx={{
          marginTop: topMargin,
          textAlign: "right",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            alignItems: "flex-start",
            // paddingX: "1rem",
            // maxWidth: "100%",
          }}
        >
          <Box
            sx={{
              position: "relative",
              paddingX: "10px",
              paddingY: "15px",
              borderTopLeftRadius: borderRadius,
              borderTopRightRadius: borderRadius,
              borderBottomLeftRadius: borderRadius,
              wordBreak: "break-word",
              backgroundColor: themeMode === "dark" ? "#033319" : "#1A5632",
              color: "white",
              textAlign: "left",
            }}
          >
            <ReactMarkdown components={{ a: LinkRenderer }} remarkPlugins={[remarkGfm]} className="markdown-content">
              {message.Message}
            </ReactMarkdown>
          </Box>
          {messageTime && (
            <Typography
              variant="caption"
              sx={{
                mt: 0.25,
                px: 0.25,
                color: themeMode === "dark" ? "#bcbcbc" : "#767676",
              }}
            >
              {messageTime}
            </Typography>
          )}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      key={index}
      sx={{
        marginTop: topMargin,
        textAlign: "left",
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <Avatar style={{ marginRight: "8px", width: "10%", maxWidth: "60px", height: "10%", flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box
          sx={{
            paddingX: "10px",
            paddingY: "15px",
            borderTopLeftRadius: borderRadius,
            borderTopRightRadius: borderRadius,
            borderBottomRightRadius: borderRadius,
            wordBreak: "break-word",
            backgroundColor: "#f5f5f5",
          }}
        >
          <ReactMarkdown components={{ a: LinkRenderer }} remarkPlugins={[remarkGfm]} className="markdown-content">
            {message.Message}
          </ReactMarkdown>
        </Box>
        <ChatbotResponse
          response={message.Message}
          chatId={message.ChatId}
          onFeedbackSubmit={onFeedbackSubmit}
          isIntroduction={message.introductionMessage}
        />
        {message.responsesOptions && isLastMessage && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "flex-end", mt: 1 }}>
            {message.responsesOptions.map(([displayText, value], idx) => (
              <ResponseOptionButton key={idx} displayText={displayText} value={value} onClick={onOptionClick} />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ChatMessage;
